module.exports = __webpack_public_path__ + "img/charger-1.ea095b6a.jpg";